module.exports = require('./helpers/bundle-url').getBundleURL('aw6oN') + "logo-dark.eefe0b7f.svg";